var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcCiMenuOption = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_CI",
  transform: "translate(4803 10703)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_loan_portfolio_management",
  transform: "translate(-5298 -10821)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_142",
  "data-name": "Rectangle 142",
  d: "M0,0H34V34H0Z",
  transform: "translate(495 118)",
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Union_244",
  "data-name": "Union 244",
  d: "M5.378,29.722A7.246,7.246,0,0,1,.971,26.361c-.13-.235-.479-1.1-.506-1.168A5.828,5.828,0,0,1,.18,24.08a11.151,11.151,0,0,1,2.014-8.515,21.736,21.736,0,0,1,4.884-5.04.924.924,0,0,1,.524-.167q3.831-.016,7.662,0a.759.759,0,0,1,.444.125,19.264,19.264,0,0,1,6.212,7.4,9.969,9.969,0,0,1,.347,7.627,6.867,6.867,0,0,1-4.552,4.135,18.046,18.046,0,0,1-5.708.853q-.371.007-.743.007A19.012,19.012,0,0,1,5.378,29.722ZM7.18,9.7c-.661,0-.957-.089-.965-.274s.3-.286.936-.286q2.431,0,4.862,0h3.648c.4,0,.765.024.905.2.167.2-.173.362-.817.364-.978,0-1.958,0-2.936,0H7.18Zm7.88-1.211c-1.211-.04-2.425-.014-3.639-.014v0c-1.246,0-2.49-.009-3.736.007A.661.661,0,0,1,7,8.1C6.13,6.494,5.235,4.9,4.354,3.3a1.657,1.657,0,0,1-.17-.451c-.139-.647.194-.994.824-.819A12.525,12.525,0,0,1,6.4,2.56a2.551,2.551,0,0,0,2.991-.6c.31-.305.612-.617.929-.915a1.385,1.385,0,0,1,2.2.217c.206.288.379.6.589.887a1.929,1.929,0,0,0,2.94.5,7.32,7.32,0,0,1,1.4-.822.957.957,0,0,1,.857.142c.134.128.077.584-.033.831-.777,1.725-1.6,3.429-2.384,5.152a.75.75,0,0,1-.77.542Z",
  transform: "translate(-4797.433 -10701.25)",
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("path", {
  id: "_",
  "data-name": "$",
  d: "M8.606-3.24A3.594,3.594,0,0,1,7.431-.755,4.008,4.008,0,0,1,4.7.137a3.881,3.881,0,0,1-2.1-.564,3.7,3.7,0,0,1-1.4-1.6A5.785,5.785,0,0,1,.7-4.443v-.93a5.827,5.827,0,0,1,.5-2.481A3.761,3.761,0,0,1,2.628-9.509a4,4,0,0,1,2.157-.581,3.838,3.838,0,0,1,2.652.9A3.741,3.741,0,0,1,8.606-6.665H6.884a2.459,2.459,0,0,0-.625-1.548,2.067,2.067,0,0,0-1.473-.475,2.02,2.02,0,0,0-1.733.824,4.114,4.114,0,0,0-.619,2.417v.882a4.364,4.364,0,0,0,.578,2.461A1.917,1.917,0,0,0,4.7-1.258a2.236,2.236,0,0,0,1.531-.458A2.388,2.388,0,0,0,6.884-3.24ZM11.977,0H10.254V-9.953h1.723Z",
  transform: "translate(-4793 -10675)",
  fill: "#FFFFFF"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcCiMenuOption);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/Ic_Ci_Menu_Option.9d0c4923eae0fc1e8d5be23149dcfd66.svg";